import { render, staticRenderFns } from "./ExemptionOrderComponent.vue?vue&type=template&id=5210b781&scoped=true"
import script from "./ExemptionOrderComponent.vue?vue&type=script&lang=ts"
export * from "./ExemptionOrderComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExemptionOrderComponent.vue?vue&type=style&index=0&id=5210b781&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210b781",
  null
  
)

export default component.exports